import { DatosPersonales, direccionPerfilVacia } from '../models/perfil.models';

export type PerfilMockKey = 'camilo' | 'carmen' | 'damian';

function perfilBase(
  parcial: Partial<DatosPersonales> &
    Pick<
      DatosPersonales,
      | 'primerNombre'
      | 'segundoNombre'
      | 'primerApellido'
      | 'segundoApellido'
      | 'runPasaporte'
      | 'nacionalidad'
      | 'fechaNacimiento'
      | 'sexoRegistral'
      | 'correoPrincipal'
      | 'telefono'
      | 'region'
      | 'ciudad'
      | 'pais'
      | 'institucionActual'
      | 'cargoRol'
      | 'departamentoUnidad'
      | 'tipoVinculo'
    >
): DatosPersonales {
  return {
    runBloqueado: true,
    generoRegistral: parcial.sexoRegistral,
    generoDeclarativo: '',
    nombreSocialCompleto: '',
    correoAlternativo: '',
    direcciones: [
      {
        ...direccionPerfilVacia(),
        tipo: 'Particular',
        paisResidencia: parcial.pais,
        region: parcial.region,
        comuna: parcial.ciudad,
        calleNumeroDepto: '',
        referenciaAdicional: '',
      },
    ],
    linkedinAcademico: '',
    discapacidad: '',
    discapacidadSiNo: '',
    pueblosOriginarios: '',
    puebloOriginario: '',
    puebloAlQuePertenece: '',
    tieneHijos: '',
    cantidadHijos: null,
    conyugeConviviente: '',
    ultimoBloque: 'identidad',
    ...parcial,
  };
}

export const PERFILES_PERSONALES_MOCK: Record<PerfilMockKey, DatosPersonales> = {
  camilo: perfilBase({
    primerNombre: 'Camilo',
    segundoNombre: 'Andres',
    primerApellido: 'Garcia',
    segundoApellido: 'Cisterna',
    runPasaporte: '12.345.678-9',
    nacionalidad: 'Chilena',
    fechaNacimiento: '1990-06-14',
    sexoRegistral: 'Masculino',
    correoPrincipal: 'cgarcia@chile.cl',
    telefono: '+56 9 8765 4321',
    region: 'Metropolitana',
    ciudad: 'Santiago',
    pais: 'Chile',
    institucionActual: 'Agencia Nacional de Investigacion y Desarrollo',
    cargoRol: 'Gestor institucional',
    departamentoUnidad: 'Subdireccion de Investigacion Aplicada',
    tipoVinculo: 'Contrato',
  }),
  carmen: perfilBase({
    primerNombre: 'Carmen',
    segundoNombre: 'Janeth',
    primerApellido: 'Pachon',
    segundoApellido: 'Caro',
    runPasaporte: '15.234.567-8',
    nacionalidad: 'Chilena',
    fechaNacimiento: '1986-03-22',
    sexoRegistral: 'Femenino',
    correoPrincipal: 'cpachon@chile.cl',
    telefono: '+56 9 6543 2100',
    region: 'Metropolitana',
    ciudad: 'Santiago',
    pais: 'Chile',
    institucionActual: 'Universidad de Chile',
    cargoRol: 'Investigadora responsable',
    departamentoUnidad: 'Facultad de Ingenieria',
    tipoVinculo: 'Contrato',
  }),
  damian: perfilBase({
    primerNombre: 'Damian',
    segundoNombre: '',
    primerApellido: 'Cisterna',
    segundoApellido: '',
    runPasaporte: '18.765.432-1',
    nacionalidad: 'Chilena',
    fechaNacimiento: '1994-08-11',
    sexoRegistral: 'Masculino',
    correoPrincipal: 'dcisterna@chile.cl',
    telefono: '+56 9 1122 3344',
    region: 'Metropolitana',
    ciudad: 'Santiago',
    pais: 'Chile',
    institucionActual: 'Agencia Nacional de Investigacion y Desarrollo',
    cargoRol: 'Coordinador de plataforma',
    departamentoUnidad: 'Subdireccion de Sistemas',
    tipoVinculo: 'Contrato',
  }),
};

export const DATOS_PERSONALES_MOCK: DatosPersonales = PERFILES_PERSONALES_MOCK.camilo;
